// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const noop: (...args: any[]) => void = () => {}
